import { render } from "./PermissionsNotice.vue?vue&type=template&id=a43011bc"
import script from "./PermissionsNotice.vue?vue&type=script&lang=js"
export * from "./PermissionsNotice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__